import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {fetchApplications} from "../Declaration/declarationSlice";
import {api} from "../../app/api";

export const fetchStories = createAsyncThunk(
    'stories/fetchStories',
    async () => {
        api.defaults.headers = {
            Authorization: `Bearer ${localStorage.getItem('token')}`
        }
        const response = await api.get('/stories')
        return response.data
    }
)

const storiesSlice = createSlice({
    name: 'Stories',
    initialState: {
        storyLoading: false,
        stories: '',
        error: {
            failed: false,
            message: null,
        },
    },
    extraReducers: {
        [fetchStories.pending]: (state) => {
            state.error.failed = false;
            state.error.message = null;
        },
        [fetchStories.fulfilled]: (state, action) => {
            state.stories = action.payload
        },
        [fetchStories.rejected]: (state, action) => {
            state.error.failed = true;
            state.error.message = action.payload;
        },
    }
})

export default storiesSlice.reducer